/*
 * Header Messages
 *
 * This contains all the text for the Header component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'boilerplate.components.Footer';

export default defineMessages({
  powered:{
    id: `${scope}.powered`,
    defaultMessage: 'powered by'
  },
  disclaimer:{
    id: `${scope}.disclaimer`,
    defaultMessage: 'piattaforma che abilita alla vendita di Noleggio a Lungo Termine, ideata e brevettata da Daicar Rent Srl'
  },
});
